import * as yup from 'yup';

export const validations = yup.object().shape({
  password: yup
    .string()
    .test(function(password) {
      if(!!this.parent.userId) {
        return true;
      }

      if(!password) {
        return this.createError({
          message: 'A senha é obrigatória',
          path: 'password'
        });
      }

      if(!/^(?=.*[A-Z]).+$/.test(password)) {
        return this.createError({
          message: 'Pelo menos 1 letra maiúscula (A-Z)',
          path: 'password'
        });
      }

      if(!/^(?=.*[a-z]).+$/.test(password)) {
        return this.createError({
          message: 'Pelo menos 1 letra minúscula (a-z)',
          path: 'password'
        });
      }

      if(!/^(?=.*\d).+$/.test(password)) {
        return this.createError({
          message: 'Pelo menos 1 número (0-9)',
          path: 'password'
        });
      }

      if(!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
        return this.createError({
          message: 'Pelo menos 1 caractere especial',
          path: 'password'
        });
      }

      if(password?.length < 8) {
        return this.createError({
          message: 'Mínimo de 8 caracteres',
          path: 'password'
        });
      }

      return true;
    }),
  passwordConfirm: yup
    .string()
    .when('password', (password, schema) => password ? schema.required('Confirme a senha') : schema)
    .oneOf([yup.ref('password'), null], 'A senha e a confirmação devem ser iguais')
});